import { render, staticRenderFns } from "./CardDividas.vue?vue&type=template&id=01d26185&"
import script from "./CardDividas.vue?vue&type=script&lang=js&"
export * from "./CardDividas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports